<div class="nav-menu">
  <!-- Top: User manager and nav menu -->
  <div class="nav-menu__top">
    @if (showUserManagementIcon) {
      <div class="user-manager">
        <span class="product-by">{{ 'a_product_of' | translate }}</span>
        <img (click)="gotoUrl()" [src]="theme.userManagement?.img" [alt]="theme.userManagement?.name" class="partner-logo" height="30">
      </div>
    }
    <ul class="nav-menu__list">
      @for (nav of headerNav; track $index) {
        <li class="nav-menu__item">
          <a [routerLink]="getNavLink(nav)" class="nav-link" routerLinkActive="active" (click)="closeMenu()">{{ nav.name | translate }}</a>
        </li>
      }
    </ul>
  </div>

  <!-- Middle: Language selector and download buttons -->
  <div class="nav-menu__middle">
    @if (showLanguageSwitcher) {
    <div class="lang-select">
      <button
        class="btn dropdown-toggle btn-outline-primary"
        type="button"
        id="langDropdownBtn"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <!-- <img [src]="(selectedLanguage | async)?.image" alt="" /> -->
        {{ (selectedLanguage | async)?.name }}
      </button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="langDropdownBtn">
        @for (lang of languagesOffered; track $index) {
          <button
            type="button"
            class="dropdown-item" type="button"
            (click)="selectLanguage(lang)">
            {{lang.name | translate}}
            <img src="{{lang.image}}" alt="">
          </button>
        }
      </div>
    </div>
    }
    <button class="download-btn--files" role="link" routerLink="/turf/gratuits" (click)="closeMenu()">
      <i class="icon-download"></i>
      {{ 'official_programs' | translate }}
    </button>
    @if (theme.mobileAppOpts.canDownloadApk) {
      <button class="download-btn--app" (click)="downloadApkAlert()">
        <i class="icon-download"></i>
        {{ 'download_app' | translate }}
      </button>
    }
  </div>

  <!-- Bottom: Quick links and logos -->
  <div class="nav-menu__bottom">
    <div class="quick-links-title">
      {{ 'quick_links' | translate }}
    </div>
    <div class="quick-links">
      @for (link of footerNav; track $index) {
        <a [routerLink]="[link.url]" class="nav-link" (click)="closeMenu()">
          {{ link.name | translate }}
        </a>
      }
    </div>
    <div class="nav-menu__logos">
      <div class="footer-legal">
        @for (legalIcon of legalIcons; track $index) {
          <img [src]="legalIcon.src" [alt]="legalIcon.alt" height="32" />
        }
      </div>
      <div class="footer-payments">
          @for (payment of paymentProviders; track $index) {
              <img [src]="payment.src" [alt]="payment.title" height="32" />
          }
      </div>
    </div>

    <div class="nav-menu__copyright">
      <span>&copy; {{ 'copyright_txt' | translate: {year: currentYear} }}</span>
    </div>
  </div>
</div>
